import { render, staticRenderFns } from "./OrdinalBrush.vue?vue&type=template&id=7b0a5264&"
import script from "./OrdinalBrush.vue?vue&type=script&lang=js&"
export * from "./OrdinalBrush.vue?vue&type=script&lang=js&"
import style0 from "./OrdinalBrush.vue?vue&type=style&index=0&id=7b0a5264&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports